<template>
  <div
    class="modal"
    v-if="isOpen"
    @click="closeModalOnClickOutSide($event)"
    :style="{
      background: this.isBackgroundTransparent ? 'transparent' : '',
    }"
  >
    <div
      class="modal_body"
      :style="{
        'min-width': this.minWidth,
        'min-height': this.minHeight,
        top: this.location.y + 'px',
        left: this.location.x + 'px',
      }"
    >
      <button
        v-if="isCloseButton"
        @click="closeModal"
        class="modal_body_close-btn"
      >
        X
      </button>
      <slot></slot>
    </div>
  </div>
</template>
<script>
export default {
	name: "Modal",
	props: [
		"openModal",
		"isCloseButton",
		"closeModalFunction",
		"minWidth",
		"minHeight",
		"isBackgroundTransparent",
		"top",
		"left",
		"closeModalonClickOutSide"
	],
	data: () => ({
		isOpen: false,
		location: {
			x: "50%",
			y: "50%"
		}
	}),
	watch: {
		openModal: function() {
			this.isOpen = this.openModal;
		},
		top: function() {
			this.location.x = this.left;
			this.location.y = this.top;
		}
	},

	methods: {
		closeModal() {
			if (this.closeModalFunction) {
				this.closeModalFunction();
			}
			this.isOpen = false;
		},
		closeModalOnClickOutSide(e) {
			if (!this.closeModalonClickOutSide) {
				return;
			}
			if (e.target.className === "modal") {
				this.closeModal();
			}
		}
	}
};
</script>
<style lang="scss" scoped>
.modal {
  background: rgba($color: black, $alpha: 0.5);
  width: 100vw;
  height: 100vh;
  position: fixed;
  left: 0;
  top: 0;
  z-index: 100000;
  display: flex;
  align-items: center;
  justify-content: center;
  .modal_body {
    position: absolute;
    background-color: white;
    display: flex;
    flex-direction: column;
    min-width: 30%;
    min-height: 50%;
    border-radius: 5px;
    padding: 1rem;
    box-shadow: 5px 5px 25px rgba(0, 0, 0, 0.4);
  }
  .modal_body_close-btn {
    background-color: transparent;
    border: none;
    font-size: 2rem;
    outline: none;
    &:hover {
      cursor: pointer;
      font-weight: bold;
    }
  }
}
</style>
